import Vue from 'vue';

const state = {
  roles: {}
}

const getters = {
  
  role (state) {
    return id => {
      if (id in state.roles) return state.roles[id];
      else return false;
    }
  },

  roles (state) {
    return state.roles;
  }

}

const mutations = {

  storeRoles (state, roles) {
    roles.forEach(role => {
      var current = state.roles[role._id] || {};
      Vue.set(state.roles, role._id, {
        ...current,
        ...role
      });
    });
  },

  removeRole (state, id) {
    if (id in state.roles) Vue.delete(state.roles, id);
  },

  clearRoles () {
    Vue.set(state, 'roles', {});
  }

}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/role.js